import rp, { CodeEditorAdapter, CodeEditor } from "@reporting/rp-app-host";
import { msg } from "@omegagrid/localize";
import { SsoSamlParams } from "@reporting/rp-types/accounting";

export class SsoSamlParamCodeEditorAdapter extends CodeEditorAdapter<CodeEditor> {

	constructor(
		private g: number,
		private type: 'idp' | 'sp' | 'security' | 'transform',
	) { super() }

	async getContent(): Promise<string> {
		const params = await rp.ms('accounting').get<SsoSamlParams>('ssoSamlParams');
		return params[this.type as keyof SsoSamlParams] as string || '';
	}

	async save(json: string) {
		const data: SsoSamlParams = {
			id_group: this.g,
			[this.type]: json
		};
		await rp.ms('accounting').post(`ssoSamlParams`, data);
	}

}
